import { converters } from "../mixins/converters";
import { EventBus } from "../src/eventBus";
import { GraphData } from "./graphData";
export const AppSalesTabNC = {
	mixins: [converters],
	data() {
		return {
			map: [],
			headings: [
				{ value: "", colspan: 1, isBorder: true, sort_by_ascending: false },
				{ value: "This Year", colspan: 1, isBorder: true, sort_by_ascending: false },
				{ value: "Last Period", colspan: 1, isBorder: true, sort_by_ascending: false },
				{ value: "Last Year", colspan: 1, isBorder: true, sort_by_ascending: false },
				{ value: "YoY%", colspan: 1, isBorder: true, sort_by_ascending: false },
				{ value: "Total YTD", colspan: 1, isBorder: true, sort_by_ascending: false },
				// { value: "Forecast", colspan: 1, isBorder: true, sort_by_ascending: false },
				// { value: "Difference", colspan: 1, isBorder: true, sort_by_ascending: false },
				// { value: "Accuracy%", colspan: 1, isBorder: true, sort_by_ascending: false }
			],
			headingsADT: [
				{ value: "", colspan: 1, isBorder: true, sort_by_ascending: false },
				{ value: "ADT", colspan: 1, isBorder: true, sort_by_ascending: false },
				{ value: "Total Txns", colspan: 1, isBorder: true, sort_by_ascending: false },
				{ value: "Last Period", colspan: 1, isBorder: true, sort_by_ascending: false },
				{ value: "Last Year", colspan: 1, isBorder: true, sort_by_ascending: false },
				{ value: "YoY%", colspan: 1, isBorder: true, sort_by_ascending: false },
				{ value: "Total YTD", colspan: 1, isBorder: true, sort_by_ascending: false },
				{ value: "ADT", colspan: 1, isBorder: true, sort_by_ascending: false },
				{ value: "Total Txns", colspan: 1, isBorder: true, sort_by_ascending: false },
				{ value: "Difference", colspan: 1, isBorder: true, sort_by_ascending: false },
				{ value: "Accuracy%", colspan: 1, isBorder: true, sort_by_ascending: false }
			],
			contributonViewHeadings: [
				{ value: "", colspan: 1, isBorder: true, sort_by_ascending: false },
				{ value: "This Year", colspan: 2, isBorder: true, sort_by_ascending: false },
				{ value: "Last Period", colspan: 2, isBorder: true, sort_by_ascending: false },
				{ value: "Last Year", colspan: 2, isBorder: true, sort_by_ascending: false },
				{ value: "YoY%", colspan: 1, isBorder: true, sort_by_ascending: false },
				{ value: "Total YTD", colspan: 2, isBorder: true, sort_by_ascending: false },
				{ value: "Forecast", colspan: 1, isBorder: true, sort_by_ascending: false },
				{ value: "Difference", colspan: 1, isBorder: true, sort_by_ascending: false },
				{ value: "Accuracy%", colspan: 1, isBorder: true, sort_by_ascending: false }
			],
			contributonViewHeadingsNew: [
				{ value: "", colspan: 1, isBorder: false, sort_by_ascending: false },
				{ value: "This Year", colspan: 2, isBorder: true, sort_by_ascending: false },
				{ value: "Last Period", colspan: 2, isBorder: true, sort_by_ascending: false },
				{ value: "Last Year", colspan: 2, isBorder: true, sort_by_ascending: false },
				{ value: "YoY%", colspan: 1, isBorder: false, sort_by_ascending: false },
				{ value: "Total YTD", colspan: 2, isBorder: true, sort_by_ascending: false },
				// { value: "Forecast", colspan: 1, isBorder: true, sort_by_ascending: false },
				// { value: "Difference", colspan: 1, isBorder: true, sort_by_ascending: false },
				// { value: "Accuracy%", colspan: 1, isBorder: true, sort_by_ascending: false }
			],
			headingMain: [
				{ value: "", colspan: 1, isBorder: false, sort_by_ascending: false },
				{ value: "Actual", colspan: 4, isBorder: true, sort_by_ascending: false },
				{ value: "", colspan: 1, isBorder: false, sort_by_ascending: false }
				// { value: "Forecast", colspan: 4, isBorder: true, sort_by_ascending: false }
			],
			headingMainATD: [
				{ value: "", colspan: 1, isBorder: false, sort_by_ascending: false },
				{ value: "Actual", colspan: 6, isBorder: true, sort_by_ascending: false },
				{ value: "Forecast", colspan: 4, isBorder: true, sort_by_ascending: false },
				// { value: "", colspan: 2, isBorder: false, sort_by_ascending: false }
			],
			contributionViewHeadingsMain: [
				{ value: "", colspan: 1, isBorder: false, sort_by_ascending: false },
				{ value: "Actual", colspan: 7, isBorder: true, sort_by_ascending: false },
				// { value: "", colspan: 1, isBorder: true, sort_by_ascending: false }
				{ value: "Forecast", colspan: 5, isBorder: true, sort_by_ascending: false }
			],
			contributionViewHeadingsMainNew: [
				{ value: "", colspan: 1, isBorder: false, sort_by_ascending: false },
				{ value: "Actual", colspan: 7, isBorder: true, sort_by_ascending: false },
				{ value: "", colspan: 2, isBorder: false, sort_by_ascending: false }
				// { value: "Forecast", colspan: 5, isBorder: true, sort_by_ascending: false }
			],
			subHeading: [
				{ value: "", colspan: 1, isBorder: true, sort_by_ascending: false },
				{ value: "quantity", colspan: 1, isBorder: true, sort_by_ascending: false },
				{ value: "%", colspan: 1, isBorder: true, sort_by_ascending: false },
				{ value: "quantity", colspan: 1, isBorder: true, sort_by_ascending: false },
				{ value: "%", colspan: 1, isBorder: true, sort_by_ascending: false },
				{ value: "quantity", colspan: 1, isBorder: true, sort_by_ascending: false },
				{ value: "%", colspan: 1, isBorder: true, sort_by_ascending: false },
				{ value: "", colspan: 1, isBorder: true, sort_by_ascending: false },
				{ value: "quantity", colspan: 1, isBorder: true, sort_by_ascending: false },
				{ value: "%", colspan: 1, isBorder: true, sort_by_ascending: false },
				{ value: "", colspan: 1, isBorder: true, sort_by_ascending: false },
				{ value: "", colspan: 1, isBorder: true, sort_by_ascending: false },
				{ value: "", colspan: 1, isBorder: true, sort_by_ascending: false }
			],
			subHeadingNew: [
				{ value: "", colspan: 1, isBorder: true, sort_by_ascending: false },
				{ value: "quantity", colspan: 1, isBorder: true, sort_by_ascending: false },
				{ value: "%", colspan: 1, isBorder: true, sort_by_ascending: false },
				{ value: "quantity", colspan: 1, isBorder: true, sort_by_ascending: false },
				{ value: "%", colspan: 1, isBorder: true, sort_by_ascending: false },
				{ value: "quantity", colspan: 1, isBorder: true, sort_by_ascending: false },
				{ value: "%", colspan: 1, isBorder: true, sort_by_ascending: false },
				{ value: "", colspan: 1, isBorder: true, sort_by_ascending: false },
				{ value: "quantity", colspan: 1, isBorder: true, sort_by_ascending: false },
				{ value: "%", colspan: 1, isBorder: true, sort_by_ascending: false },
				// { value: "", colspan: 1, isBorder: true, sort_by_ascending: false },
				// { value: "", colspan: 1, isBorder: true, sort_by_ascending: false },
				// { value: "", colspan: 1, isBorder: true, sort_by_ascending: false }
			],
			tableData: {
				data: {
					headingMain: [],
					headings: [],
					subHeading: [],
					rows: []
				}
			},
			basicsMapping: {
				country: "Country Name",
				state: "State Name",
				region: "Region Name",
				subregion: "Subregion Name",
				outlet: "Store Name",
				department: "Department Name",
				category: "Category Name",
				subcategory: "Subcategory Name",
				product: "Product Name"
			}
		};
	},

	methods: {
		AnalyticsDataNC(
			tableDataResponse,
			tableType,
			mappingArray,
			consolidatedTableData
		) {
			// console.log(this.selectSalesView, JSON.parse(tableDataResponse.data), tableType, mappingArray, JSON.parse(consolidatedTableData.data));
			if (consolidatedTableData.data) {
				// get the consolidated for rows in table
				var consolidatedData = JSON.parse(consolidatedTableData.data);
			}

			if (tableDataResponse.data) {
				// get the table rows data
				const responseData = JSON.parse(tableDataResponse.data);

				if (
					// if quickreport is one of these below transform data for table and bar graph
					tableType == "mtd" ||
					tableType == "wtd" ||
					tableType == "sale" ||
					tableType == "qtd" ||
					tableType == "ytd"
				) {
					console.log("this.basics", this.basics);
					let tableRows = this.analyticsTableData(
						responseData.results,
						tableType,
						mappingArray,
						consolidatedData.results,
						this.isContributionView,
						this.basics,
						this.selectSalesView
					);
					
					if (this.selectSalesView == "adt") {
						this.tableData.data.headingMain = this.isContributionView ? this.contributionViewHeadingsMain : this.headingMainATD;
						
						this.tableData.data.headings = this.isContributionView ? this.contributonViewHeadings : this.headingsADT;

						console.log(this.tableData)
						
						this.tableData.data.headings[0].value = this.basicsMapping[this.basics];

						this.tableData.data.subHeading = this.isContributionView ? this.subHeading : [];
					
					} else if (this.selectSalesView == "contribution_sale")  {
						this.tableData.data.headingMain = this.isContributionView
							? this.contributionViewHeadingsMain
							: this.headingMain;
						this.tableData.data.headings = this.isContributionView
							? this.contributonViewHeadings
							: this.headings;
						this.tableData.data.headings[0].value = this.basicsMapping[
							this.basics
						];
						this.tableData.data.subHeading = this.isContributionView
							? this.subHeading
							: [];
					} else {
						{
							this.tableData.data.headingMain = this.isContributionView
								? this.contributionViewHeadingsMainNew
								: this.headingMain;
							this.tableData.data.headings = this.isContributionView
								? this.contributonViewHeadingsNew
								: this.headings;
							this.tableData.data.headings[0].value = this.basicsMapping[
								this.basics
							];
							this.tableData.data.subHeading = this.isContributionView
								? this.subHeadingNew
								: [];
						}
					}
					
					this.tableData.data.rows = tableRows;
					console.log(this.tableData);
					this.$store.commit("setAnalyticsData", this.tableData);

					// extract data for graph
					const tableRowsForGraph = tableRows.slice(); // copy the tableRows array to tableRowsForGraph array
					tableRowsForGraph.shift(1); // remove the consolidated row from the tableRowsForGraph to plot the graph
					// const graphData = this.toDateGroupGraph(tableRowsForGraph); // transform the data for graph
					const graphData = this.toDateGroupGraph(responseData.results, mappingArray); // transform the data for graph

					for (let k = 0; k < this.allSalesView.lenght; k++) {
						if (this.allSalesView[k].id == this.selectSalesView) {
						}
					}

					let name = "";

					if (this.selectSalesView == "amt") {
						name = "Sales";
					} else if (this.selectSalesView == "adt") {
						name = "Average Daily Transaction";
					} else if (this.selectSalesView == "at") {
						name = "Average Ticket Size";
					} else if (this.selectSalesView == "ipt") {
						name = "Item Per Transaction";
					} else if (this.selectSalesView == "contribution_amt") {
						name = "Contribution Amount";
					} else if (this.selectSalesView == "contribution_sale") {
						name = "Contribution Sale";
					} else if (this.selectSalesView == "qty") {
						name = "Sale Quantity";
					}
					this.$store.commit("setNameOfGraph", name);
					this.$store.commit("setGraphData", graphData);

					// EventBus.$emit("callRerender", this.$route.name); // emit an event to call rerender function in woowgraph componenent

					this.$store.commit('setGraphReRenderStatus', new Date().getTime());  //call rerender function in woowgraph componenent
					EventBus.$emit("checkView", name); // emit an event to call rerender function in woowgraph componenent
				}

				if (tableType == "mom") {
					// if quickreport is one of these below transform data for table and bar graph

					let tableRows = this.analyticsMomTableData(
						responseData.results,
						tableType,
						mappingArray,
						consolidatedData.results
					);
					tableRows[0][0].value = this.basicsMapping[this.basics]; // basics is the heading of first column of the table. tableRows[0][0] is the heading row here.

					// extract data for graph
					this.plotOnlyDateGroupGraph(tableRows[0], tableRows[1]);

					this.tableData.data.headingMain = [];
					this.tableData.data.headings = tableRows.shift(0); // remove the headings array from tableRows and add it to this.tableData headings.
					this.tableData.data.rows = tableRows; // set the this.tableData rows.
					console.log(this.tableData);
					this.$store.commit("setAnalyticsData", this.tableData);
				}

				if (
					// if quickreport is one of these below transform data for table and bar graph
					tableType == "day" ||
					tableType == "week" ||
					tableType == "month" ||
					tableType == "quarter" ||
					tableType == "year" ||
					tableType == "wow"
				) {
					let tableRows = this.queryTableData(
						responseData.results,
						tableType,
						mappingArray,
						consolidatedData.results
					);
					tableRows[0][0] = {
						value: this.basicsMapping[this.basics],
						isBorder: true
					}; // basics is the heading of first column of the table. tableRows[0][0] is the heading row here.

					this.plotOnlyDateGroupGraph(tableRows[0], tableRows[1]);

					this.tableData.data.headingMain = [];
					this.tableData.data.headings = tableRows.shift(0); // remove the headings array from tableRows and add it to this.tableData headings.
					this.tableData.data.rows = tableRows; // set the this.tableData rows.
					console.log("setAnalyticsData", this.tableData);
					this.$store.commit("setAnalyticsData", this.tableData);

					// const graphData = this.onlyDateGraph(tableRows);
				}
				// EventBus.$emit("showLoader", false);
			}
		},

		plotOnlyDateGroupGraph(headings, tableRow1) {
			// this.$store.commit("setNameOfGraph", "consolidated");
			const graphData = this.onlyDateGroupGraph(headings, tableRow1);
			EventBus.$emit("disableFirstButton", false);
			this.$store.commit("setGraphData", graphData);
			// EventBus.$emit("callReRenderOneBarGraph", false);
			this.$store.commit('setGraphVisibility', new Date().getTime());
		}
	}
};
